import React from 'react'
import { Outlet } from 'react-router-dom'

import {
  FormEditPage,
  FormListPage,
  FormDetailPage,
  FormChoosePage,
  FormSubmissionPage
} from './pages'

export const routes = {
  user: [
    {
      path: 'questionarios',
      label: 'Questionários',
      element: <Outlet />,
      children: [
        {
          path: '',
          label: 'Questionários',
          element: <FormChoosePage />
        },
        {
          path: ':formId/*',
          label: 'Questionários',
          element: <FormSubmissionPage />
        }
      ]
    }
  ],
  admin: [
    {
      path: 'questionarios',
      label: 'Questionários',
      element: <Outlet />,
      children: [
        { path: '', element: <FormListPage /> },
        { path: 'criar', label: 'Criar Questionário', element: <FormEditPage isCreate /> },
        {
          path: ':formId',
          label: ({ formId }) => `Questionário #${formId}`,
          element: <Outlet />,
          children: [
            {
              path: '',
              element: <FormDetailPage />
            },
            {
              path: 'editar',
              label: 'Editar',
              element: <FormEditPage />
            }
          ]
        }
      ]
    }
  ]
}
